import { SecondaryMarketProductSearch } from 'components/secondaryMarket';
import { ConnectedTabsWorkspace } from 'components/shared/DragAndDropWorkspace/TabsWorkspace';
import { QuoteWorkspaceProvider } from 'contexts/quote-workspace.context';
import { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import type { SecondaryMarketQuotesTabType } from 'state/workspaces/model';
import { workspaceTabUnactivated } from 'state/workspaces/workspace.actions';

import { SecondaryMarketQuoteTab } from './Tabs';

export const SecondaryMarketQuotesWorkspace: FC = () => {
  const dispatch = useDispatch();
  const onAddNewTab = useCallback(() => {
    dispatch(workspaceTabUnactivated('secondaryMarketQuotes'));
  }, [dispatch]);

  return (
    <QuoteWorkspaceProvider value="secondaryMarketQuotes">
      <ConnectedTabsWorkspace
        workspace="secondaryMarketQuotes"
        onAddNewTab={onAddNewTab}
        paddingClassName="ps-4"
        addNewTabTooltip="secondaryMarket.addNewTab"
      >
        {tab => (
          <>
            {tab === null && <SecondaryMarketProductSearch />}
            {tab !== null && tab.type !== null && (
              <SecondaryMarketQuoteTab tabId={tab.id} tabType={tab.type as SecondaryMarketQuotesTabType} key={tab.id} />
            )}
          </>
        )}
      </ConnectedTabsWorkspace>
    </QuoteWorkspaceProvider>
  );
};

SecondaryMarketQuotesWorkspace.displayName = 'SecondaryMarketQuotesWorkspace';
